<template>
  <div class="basket" :class="{ mobile: $vuetify.breakpoint.xsOnly }">
    <v-container v-if="$vuetify.breakpoint.smAndUp">
      <v-row class="pt-5">
        <breadcrumbs :breadcrumbs="breadcrumbs" />
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-stepper alt-labels>
            <v-stepper-header>
              <v-stepper-step step="1" color="appGreen"
                >MY BASKET</v-stepper-step
              >

              <v-divider></v-divider>

              <v-stepper-step step="2" color="appGreen"
                >DELIVERY & PAYMENT</v-stepper-step
              >

              <v-divider></v-divider>

              <v-stepper-step step="3" color="appGreen"
                >THANK YOU</v-stepper-step
              >
            </v-stepper-header>
          </v-stepper>
        </v-col>
      </v-row>
      <v-row
        class="rectangle"
        v-for="(item, index) in basket_products"
        :key="index"
      >
        <v-col cols="12">
          <basket-card :item="item"></basket-card>
        </v-col>
      </v-row>
      <!-- Coupon -->
      <!-- <v-row>
        <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
        <v-col cols="12" sm="12" md="6" class="coupon">
          <h2>Have a Coupon Code?</h2>
          <v-text-field
            label="1"
            solo
            flat
            dense
            hide-details="auto"
          ></v-text-field>
          <v-btn color="appRed" class="white--text">Apply</v-btn>
        </v-col>
      </v-row> -->
      <v-row class="checkout-panel">
        <v-col cols="12">
          <v-row>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="12" md="6" class="cost-panel">
              <v-row>
                <v-col cols="6">
                  <span>Sub Total</span>
                </v-col>
                <v-col cols="6">
                  <span>£{{ basketSubTotal }}</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <span>Shipping</span>
                </v-col>
                <v-col cols="6">
                  <span>£{{ basketShippingFee }}</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <span>Discount</span>
                </v-col>
                <v-col cols="6">
                  <span>£{{ basketDiscount }}</span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col cols="12">
              <v-divider horizontal></v-divider>
            </v-col>
          </v-row> -->
          <!-- <v-row>
            <v-col cols="12" sm="12" md="6" class="guarantee">
              <v-img src="@/assets/guarantee.svg"></v-img>
              <p>Shop with ease with out 14 Day Monkey Back Gurantee</p>
            </v-col>
            <v-col cols="12" sm="12" md="6" class="total">
              <v-row>
                <v-col cols="6">
                  <span>Total</span>
                </v-col>
                <v-col cols="6">
                  <span>£{{ basketTotal }}</span>
                </v-col>
              </v-row>
            </v-col>
          </v-row> -->
        </v-col>
      </v-row>
       <v-row class="location">
        <v-col cols="12" md="8" class="left">
          <!-- <v-icon>mdi-map-marker</v-icon>
          <p>123 Dale Hall Lane, Ipswich, IP1 4LS</p>
          <p><v-icon>mdi-chevron-left</v-icon> <span>Change Address?</span></p> -->
        </v-col>
        <v-col cols="12" md="4" class="right">
          <v-btn @click="navigateToCheckout" color="appRed" class="white--text"
            >Checkout</v-btn
          >
        </v-col>
      </v-row>
      <!-- <v-row class="information">
        <v-col cols="12">
          <h2>Return & Warranty</h2>
          <ul>
            <li>100% Authentic</li>
            <li>14 days easy return</li>
            <li>Change of mind is not applicable</li>
            <li>Warranty not available</li>
          </ul>
        </v-col>
      </v-row> -->
    </v-container>
    <v-container v-if="$vuetify.breakpoint.xsOnly" class="py-0">
      <v-row>
        <v-col cols="12" class="pt-0">
          <div class="gotham-medium text-uppercase font-16 mt-5 basket-items">
            {{ basket_products.length }} Items in your basket
          </div>
        </v-col>
      </v-row>
      <v-row :style="{ 'min-height': '119px' }">
        <v-col cols="12" class="pt-0">
          <v-card ref="basketTotal" class="basket-total">
            <div class="d-flex align-baseline">
              <div>Sub Total</div>
              <div class="line"></div>
              <div>£{{ basketSubTotal }}</div>
            </div>
            <div class="d-flex align-baseline">
              <div>Shipping</div>
              <div class="line"></div>
              <div>£{{ basketShippingFee }}</div>
            </div>
            <div class="d-flex align-baseline">
              <div>Total</div>
              <div class="line"></div>
              <div>£{{ basketTotal }}</div>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-for="(item, index) in basket_products" :key="index">
        <v-col cols="12">
          <basket-card :item="item"></basket-card>
        </v-col>
      </v-row>
      <div class="basket-checkout">
        <v-btn
          @click="navigateToCheckout"
          elevation="0"
          height="48"
          block
          color="#FF6B6B"
          >Checkout</v-btn
        >
      </div>
    </v-container>
    <v-container fluid class="pa-0">
      <home-footer class="d-none d-md-block" />
    </v-container>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Breadcrumbs from "@/components/Shared/Breadcrumbs/Breadcrumbs.vue";
import HomeFooter from "@/components/Shared/HomeFooter/HomeFooter.vue";
import BasketCard from "@/components/Shared/BasketCard/BasketCard.vue";
export default {
  name: "BasketComponent",
  components: {
    Breadcrumbs,
    BasketCard,
    HomeFooter
  },
  data: () => ({
    breadcrumbs: ["ORTHODONTICS", "MY BASKET"]
  }),
  computed: {
    ...mapState({
      token: state => state.auth.token,
      basket_products: state => state.product.basketProducts
    }),
    ...mapGetters({
      basketSubTotal: "product/basketSubTotal",
      basketShippingFee: "product/basketShippingFee",
      basketDiscount: "product/basketDiscount",
      basketTotal: "product/basketTotal",
      totalBasketItems: "product/totalBasketItems",
    })
  },
  methods: {
    navigateToCheckout() {
      if (this.token === null) {
        this.$router.push({ name: "Login", query: { redirect: "/basket" } });
        return;
      }
      if (this.basket_products.length > 0) {
        this.evtCheckout();
        this.$router.push({ name: "Checkout" });
      }
    },
    stickyBasketTotalListener() {
      window.addEventListener("scroll", this.stickyBasketTotal);
    },
    stickyBasketTotal() {
      if (this.$vuetify.breakpoint.smAndUp) {
        return;
      }

      const basketTotal = this.$refs.basketTotal.$el;
      const offsetTop = 119;

      if (window.scrollY > offsetTop) {
        if (!basketTotal.classList.contains("sticky")) {
          basketTotal.classList.add("sticky");
        }
      } else if (window.scrollY < offsetTop + basketTotal.clientHeight) {
        basketTotal.classList.remove("sticky");
      }
    }
  },
  mounted() {
    this.stickyBasketTotalListener();
  },
  watch: {
    "$vuetify.breakpoint.xsOnly"() {
      this.stickyBasketTotalListener();
    },
    totalBasketItems(val) {

      if (val < 1) {
       this.$router.go(-1)
      }

    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.stickyBasketTotal);
  }
};
</script>
<style scoped lang="scss" src="./Basket.scss"></style>
<style lang="scss">
.basket-search {
  .v-input__slot {
    background: #f2f2f2 !important;
    border-radius: 5px;
  }
}
</style>
